import React, { useContext, useEffect, useRef, useState } from 'react'
import CSVUpload from '../components/csvupload/CSVUpload'
import Header from '../components/header/Header';
import { AiOutlineSearch } from 'react-icons/ai'
import FeeDetailsTable from '../components/feedetailstable/FeeDetailsTable';
import CssBaseline from "@material-ui/core/CssBaseline";
import { addStudentsDetails, resetAddStudentsDetails } from "../redux/features/student/studentSlice"
import { useSelector, useDispatch } from "react-redux"
import useToast from '../shared/Toast'
import { Spinner } from 'react-bootstrap'
import AppContext from '../storage/AppContext';

function UploadStudentsFeeDetailsContainer() {

    const [columns, setColumns] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [termAlreadyExists, setTermAlreadyExists] = useState(false)
    const showToast = useToast()

    const dispatch = useDispatch()
    const addedStudentsDetails = useSelector(state => state.student.addedStudentsDetails)
    const checkIfTermExistsDetails = useSelector(state => state.student.checkIfTermExistsDetails)

    const appContext = useContext(AppContext);

    const userDetails = appContext?.userDetails

    const feeRef = useRef(null)

    const onChangeSearchInput = (e) => {
        setSearchInput(e.target.value)
        feeRef?.current?.setFilter(e.target.value)
    }

    useEffect(() => {
        if (tableData.length !== 0) {
            for (let i = 0; i < tableData.length; i++) {
                if (tableData[i].isTermExists || tableData[i].message === "Invalid Term" || tableData[i].message === "Fields Should not be Empty") {
                    setTermAlreadyExists(true)
                    break;
                }else{
                    setTermAlreadyExists(false)
                }
            }
        }
    }, [tableData])

    useEffect(() => {
        if(tableData.length !== 0){
            for(let i = 0; i < tableData.length; i++){
                if(tableData[i].isTermExists || tableData[i].message !== "Details are Valid"){
                    alert("Uploaded Details doesn't match the Requirement")
                    break;
                }
            }
        }
    },[tableData])

    const onClickSubmit = () => {
        const termDetails = tableData.map((each) => {
            if (each["1st Term Fee"]) {
                return { "1st Term Fee": { amount: each["1st Term Fee"], paymentStatus: "Unpaid" } }
            } else if (each["2nd Term Fee"]) {
                return { "2nd Term Fee": { amount: each["2nd Term Fee"], paymentStatus: "Unpaid" } }
            } else if (each["3rd Term Fee"]) {
                return { "3rd Term Fee": { amount: each["3rd Term Fee"], paymentStatus: "Unpaid" } }
            } else if (each["4th Term Fee"]) {
                return { "4th Term Fee": { amount: each["4th Term Fee"], paymentStatus: "Unpaid" } }
            }
        })

        let studentFeeDetails = []
        for (let i = 0; i < tableData.length; i++) {
            studentFeeDetails.push({ ...tableData[i], ...termDetails[i] })
        }
        let studentDetails = studentFeeDetails.map((each) => {
            return {...each, branch:userDetails?.data?.branch}
        })
        dispatch(addStudentsDetails(studentDetails))
    }

    useEffect(() => {
        if (addedStudentsDetails.status === "succeeded") {
            showToast({ message: addedStudentsDetails.message})
            dispatch(resetAddStudentsDetails())
            setTableData([])
        }else if(addedStudentsDetails.status === "failed"){
            showToast({ message: addedStudentsDetails.error, type: 'error'})
            dispatch(resetAddStudentsDetails())
            setTableData([])
        }
    }, [addedStudentsDetails.status])

    return (
        <div>
            <Header />
            {addedStudentsDetails.status === "loading" ? 
                <div style={{ minHeight: '70vh' }} className='d-flex justify-content-center align-items-center'>
                    <Spinner animation="border" role="status"></Spinner>
                </div> :

            (
            <div className='p-2'>
            <div className='py-3 mt-2' style={{ display: "flex", alignItems:"center",justifyContent: "space-between", backgroundColor: "#f9f9f9" }}>
                <CSVUpload setTableData={setTableData} setColumns={setColumns} />
                {(tableData?.length !== 0) &&
                    <div style={{ display: "flex", alignItems: "center", padding: "10px", width: "25%", border: "1px solid #d6d6d6", borderRadius: "5px", backgroundColor: "#ffffff" }} >
                        <AiOutlineSearch size={20} />
                        <input
                            type="search"
                            value={searchInput || ""}
                            style={{ marginLeft: "5px", border: "none", outline: "none", width: "100%" }}
                            placeholder="Search"
                            onChange={(e) => onChangeSearchInput(e)}
                        />
                    </div>
                }
            </div>
            {checkIfTermExistsDetails.status === "loading" ?
                <div style={{ minHeight: '70vh' }} className='d-flex justify-content-center align-items-center'>
                    <Spinner animation="border" role="status"></Spinner>
                </div> :
                <div >
                    {(tableData?.length !== 0) &&
                        <div className='' style={{ display: "flex", flexDirection: "column" }}>
                            <div>
                                <CssBaseline />
                                <FeeDetailsTable ref={feeRef} columns={columns} data={tableData} searchInput={searchInput} />
                            </div>
                            <button onClick={onClickSubmit} disabled={termAlreadyExists} style={{backgroundColor: termAlreadyExists? "#dddddd" : "#0b54ab", alignSelf: "center", height: "40px", width: '150px', padding: "2px", borderRadius: "5px", color: '#ffffff', border: "none", fontWeight: "500", fontSize: "16px", marginBottom: "10px" }}>Submit</button>
                        </div>}
                </div>
            }
            </div>)}
        </div>
    )
}

export default UploadStudentsFeeDetailsContainer